import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { CustomizedVocab } from "./CustomizeVocab";
import { DisplayPatientComparison } from "./DisplayPatientComparison";

interface IPatientMergeRequestFinalConfirmationPopupProps {
    onClose: () => void;
    onBack: () => void;
    onConfirm: (patientAContactId: string, patientBContactId: string) => void;
    patientA: Person;
    patientB: Person;
}

function PatientMergeRequestFinalConfirmationPopup({ onClose, onBack, onConfirm, patientA, patientB }: Readonly<IPatientMergeRequestFinalConfirmationPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("WarningLabel")}
            showX
            showOverlay
            onClose={onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            variant="neutral"
                            label={getText("BackLabel")}
                            onClick={onBack}
                        />
                        <ButtonControl
                            variant="error"
                            label={getText("ConfirmLabel")}
                            onClick={() => onConfirm(patientA.ContactId, patientB.ContactId)}
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <p><CustomizedVocab labelKey="PatientMergeRequestPopup_ConfirmMergePatientBWithPatientALabel" /></p>
            <p><CustomizedVocab labelKey="PatientMergeRequestPopup_ConfirmMergePatientBWillBeDeletedLabel" /></p>
            <p className="red-text margin-md-top margin-md-bottom">{getText("PatientMergeRequestPopup_ActionCannotBeUndoneLabel")}</p>
            <DisplayPatientComparison patientA={patientA} patientB={patientB} />
            <p className="margin-xl-top">{getText("PatientMergeRequestPopup_MergeWillBeginAtMidnightTonightLabel")}</p>
        </Modal>
    );
}

export { PatientMergeRequestFinalConfirmationPopup };
